<template>
  <div class="deepsearch-page">
    <Breadcrumb :headers="headers"></Breadcrumb>
    <div class="deepsearch-container">
      <div v-if="loading" v-loading="true" class="deepsearch-loading"></div>
      <div v-else-if="error" class="deepsearch-error">
        <p>{{ errorMessage }}</p>
        <el-button type="primary" @click="retry">Retry</el-button>
      </div>
      <div v-else class="iframe-clip-wrapper" :style="clipStyle">
        <iframe
          class="deepsearch-frame"
          :src="actualUrl"
          :title="headerLabel"
          allow="clipboard-read; clipboard-write"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/common/Breadcrumb.vue";

const DEEPSEARCH_BASE = process.env.VUE_APP_DEEPSEARCH_BASE_URL || "http://127.0.0.1:3200";

const URL_CONFIG = {
  deepsearchSearch: {
    url: `${DEEPSEARCH_BASE}/embed/search`,
    title: "Search",
    clipTop: 0,
    clipLeft: 0
  },
  deepsearchFiles: {
    url: `${DEEPSEARCH_BASE}/embed/files`,
    title: "All Files",
    clipTop: 0,
    clipLeft: 0
  },
  deepsearchHistory: {
    url: `${DEEPSEARCH_BASE}/embed/history`,
    title: "Search History",
    clipTop: 0,
    clipLeft: 0
  },
  deepsearch: {
    url: `${DEEPSEARCH_BASE}/embed/`,
    title: "Deepsearch",
    clipTop: 0,
    clipLeft: 0
  }
};

const TOKEN_SAFETY_MARGIN_MS = 2 * 60 * 1000;

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      loading: false,
      error: false,
      errorMessage: "",
      token: null
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    config() {
      return URL_CONFIG[this.routeName] || URL_CONFIG.deepsearch;
    },
    headerLabel() {
      return this.config.title;
    },
    headers() {
      return [
        { label: "Home", path: "/dashboard" },
        { label: "Marketing Materials", path: "/deepsearchSearch" },
        { label: this.headerLabel, path: "/" + this.routeName }
      ];
    },
    actualUrl() {
      if (!this.token) return "";
      const url = this.config.url;
      const sep = url.includes("?") ? "&" : "?";
      return url + sep + "embed_token=" + encodeURIComponent(this.token) + "&embed=true";
    },
    clipStyle() {
      const top = this.config.clipTop;
      const left = this.config.clipLeft;
      if (top === 0 && left === 0) return {};
      return {
        marginTop: top + "px",
        marginLeft: left + "px",
        overflow: "hidden"
      };
    }
  },
  created() {
    this.ensureToken();
  },
  watch: {
    routeName() {
      this.ensureToken();
    }
  },
  methods: {
    ensureToken() {
      const cached = this.$store.state.deepsearchToken;
      const expiry = this.$store.state.deepsearchTokenExpiry;
      if (cached && expiry && expiry > Date.now() + TOKEN_SAFETY_MARGIN_MS) {
        this.token = cached;
        return;
      }
      this.fetchToken();
    },
    fetchToken() {
      this.loading = true;
      this.error = false;
      this.$http.post(
        "deepsearchExchange",
        {},
        (data) => {
          this.loading = false;
          this.token = data.data.embed_token;
          const expiresIn = data.data.expires_in || 1800;
          this.$store.commit("setDeepsearchToken", {
            token: this.token,
            expiry: Date.now() + expiresIn * 1000
          });
        },
        (err) => {
          this.loading = false;
          this.error = true;
          this.errorMessage = err.msg || "Failed to connect to DeepSearch";
        }
      );
    },
    retry() {
      this.$store.commit("clearDeepsearchToken");
      this.fetchToken();
    }
  }
};
</script>

<style scoped>
.deepsearch-page {
  height: 100%;
}

.deepsearch-container {
  height: calc(100vh - 180px);
  min-height: 600px;
  padding-top: 10px;
  box-sizing: border-box;
}

.deepsearch-loading {
  height: 100%;
  min-height: 400px;
}

.deepsearch-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  color: #909399;
}

.deepsearch-error p {
  margin-bottom: 20px;
  font-size: 14px;
}

.iframe-clip-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.deepsearch-frame {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
</style>
